<template>
    <marking-list-search></marking-list-search>
</template>

<script>
  import MarkingListSearch from "./MarkingListSearch";
  export default {
    name: "MarkingList",
    components: {MarkingListSearch},
    data() {
      return {}
    }
  }
</script>

<style scoped>

</style>
